module.exports = __webpack_public_path__ + "img/stock0.43aa1548.png";